export const API_BASE_URL = 'https://mslpgagency.cloud/api/';
export const IMAGE_BASE_URL = 'https://mslpgagency.cloud/api/';

export const VALIDATION_MESSAGES = {
  REQUIRED: 'This field is required',
  EMAIL: 'Please enter a valid email address',
  MIN_LENGTH: (min: number) => `Minimum length is ${min} characters`,
  MAX_LENGTH: (max: number) => `Maximum length is ${max} characters`,
  PASSWORD_MATCH: 'Passwords do not match',
  INVALID_NUMBER: 'Please enter a valid number',
  POSITIVE_NUMBER: 'Please enter a positive number',
}; 